import 'css-chunk:src/applications/ReportsApp/pages/Home/components/Impact/Impact.module.scss';export default {
  "container": "_container_11qkq_1",
  "title": "_title_11qkq_7",
  "tooltip": "_tooltip_11qkq_14",
  "value": "_value_11qkq_18",
  "statistic": "_statistic_11qkq_34",
  "trend": "_trend_11qkq_47"
};